type NetworkEventCallback = (data: any) => void;

export type NetworkEventType =
  | 'network:offline'
  | 'network:online'
  | 'auth:failure'
  | 'auth:link_expired'
  | 'network:error'
  | 'connection:recovered'
  | 'tab:deactivated';

class NetworkEventManager {
  private listeners: Record<string, NetworkEventCallback[]> = {};

  // Event listener registration
  public on(event: NetworkEventType, callback: NetworkEventCallback) {
    if (!this.listeners[event]) this.listeners[event] = [];
    this.listeners[event].push(callback);
  }

  public off(event: NetworkEventType, callback: NetworkEventCallback) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter(l => l !== callback);
  }

  // Emit to all listeners
  public emit(event: NetworkEventType, data: any) {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event].forEach(listener => listener(data));
  }

  // Helper methods for common events
  public emitNetworkOffline(reason: string) {
    this.emit('network:offline', { reason, timestamp: Date.now() });
  }

  public emitNetworkOnline() {
    this.emit('network:online', { timestamp: Date.now() });
  }

  public emitAuthFailure(reason: string, details?: any) {
    this.emit('auth:failure', { reason, details, timestamp: Date.now() });
  }

  public emitLinkExpired(reason: string, details?: any) {
    this.emit('auth:link_expired', { reason, details, timestamp: Date.now() });
  }

  public emitNetworkError(error: string, details?: any) {
    this.emit('network:error', { error, details, timestamp: Date.now() });
  }

  public emitConnectionRecovered() {
    this.emit('connection:recovered', { timestamp: Date.now() });
  }

  public emitTabDeactivated() {
    this.emit('tab:deactivated', { timestamp: Date.now() });
  }

  // Cleanup method
  public cleanup() {
    this.listeners = {};
  }
}

// Create and export a singleton instance
export const networkEventManager = new NetworkEventManager();
